<!-- GridMaskBG.vue -->
<template>
  <div

    :style="{
      /* grid */
      backgroundImage:
        `linear-gradient(to right, currentColor ${thicknessUnit}, transparent ${thicknessUnit}),
         linear-gradient(to bottom, currentColor ${thicknessUnit}, transparent ${thicknessUnit})`,
      backgroundSize: `${sizeUnit} ${sizeUnit}`,

      /* circle mask */
      maskImage: `radial-gradient(${maskWidth} circle at center, white, transparent)`,
      WebkitMaskImage: `radial-gradient(${maskWidth} circle at center, white, transparent)`,
      maskRepeat: 'no-repeat',
      WebkitMaskRepeat: 'no-repeat',
      maskPosition: 'center',
      WebkitMaskPosition: 'center',
    }"
  />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  thickness: { type: [Number, String], default: 1 },   // px or any CSS length
  bgSize:    { type: [Number, String], default: 40 },  // px or any CSS length
  maskWidth: { type: String, default: '95vh' },        // e.g. '95vh', '400px'
})

const unit = v => (typeof v === 'number' ? `${v}px` : v)

const thicknessUnit = computed(() => unit(props.thickness))
const sizeUnit = computed(() => unit(props.bgSize))
const maskWidth = computed(() => props.maskWidth)
</script>
